<template>
    <div>
        <LsTemplatedLoading :show="loading" :full-screen="true" test-id="loading" />
        <div v-if="!loading" class="ls-recommendation-view--columns">
            <LsServiceRecOrReqDetails
                :recommendation-or-required="recommendation"
                :services="allRecentAndCurrentServices"
                class="ls-recommendation-view--details"
                test-id="recommendation_details"
            />
            <div
                v-if="routeName === 'recommendation'"
                class="ls-recommendation-view--buttons"
                test-id="action_buttons"
            >
                <LsActionButton
                    v-for="action in recommendationActions"
                    :key="action.action"
                    v-bind="action"
                    :service="recommendation"
                />
            </div>
            <router-view v-else />
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { lsErrorService } from 'ls-vue-common';
import LsTemplatedLoading from '@/components/LsTemplatedLoading/LsTemplatedLoading.vue';
import LsServiceRecOrReqDetails from '@/components/LsServiceRecOrReqDetails/LsServiceRecOrReqDetails.vue';
import LsActionButton from '@/components/LsActionButton/LsActionButton.vue';
import { apolloClient } from '@/vue-apollo';
import Recommendation from '@/graphql/queries/Recommendation.gql';
import AllRecentAndCurrentServices from '@/graphql/queries/AllRecentAndCurrentServices.gql';
import DEFAULT_ALL_RECENT_AND_CURRENT_SERVICES from '@/graphql/queries/AllRecentAndCurrentServices.defaults';
import RecommendationActions from '@/graphql/queries/RecommendationActions.gql';

export default {
    name: 'RecommendationView',
    components: {
        LsServiceRecOrReqDetails,
        LsTemplatedLoading,
        LsActionButton,
    },
    data() {
        const variables = {
            customer_id: _.toNumber(this.$route.params.customer_id),
            property_id: _.toNumber(this.$route.params.property_id),
            id: _.toNumber(this.$route.params.recommendation_id),
        };

        let allRecentAndCurrentServices = DEFAULT_ALL_RECENT_AND_CURRENT_SERVICES;
        try {
            const result = apolloClient.readQuery({
                query: AllRecentAndCurrentServices,
                variables,
            });
            if (result && result.allRecentAndCurrentServices) {
                allRecentAndCurrentServices = result.allRecentAndCurrentServices;
            }
        } catch (e) {
            // Cache miss on deep-link
        }

        return {
            loading: 0,
            recommendation: {},
            recommendationActions: [],
            allRecentAndCurrentServices: _.concat(
                allRecentAndCurrentServices.schedules || [],
                allRecentAndCurrentServices.recommendations || [],
                allRecentAndCurrentServices.requiredServices || []
            ),
            variables,
        };
    },
    apollo: {
        recommendation: {
            query: Recommendation,
            variables() {
                return this.variables;
            },
            result({ data, loading }) {
                if (!loading) {
                    this.recommendation = {
                        ...data.recommendation.recommendation,
                        price: data.recommendation.price,
                        payout: data.recommendation.payout,
                        commission: data.recommendation.commission,
                        tax_amount: data.recommendation.tax_amount,
                        total_amount: data.recommendation.total_amount,
                    };
                }
            },
            error(error) {
                lsErrorService.log({ error });
            },
            loadingKey: 'loading',
        },
        recommendationActions: {
            query: RecommendationActions,
            variables() {
                return this.variables;
            },
            error(error) {
                lsErrorService.log({ error });
            },
            fetchPolicy: 'cache-and-network',
            loadingKey: 'loading',
        },
    },
    computed: {
        routeName() {
            return this.$route.name;
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name === 'recommendation') {
            this.$apollo.queries.recommendationActions.refetch(this.variables);
        }
        next();
    },
};
</script>

<style lang="scss" scoped>
.ls-recommendation-view--columns {
    display: flex;
    flex-direction: row;
}

.ls-recommendation-view--details {
    width: 370px;
    margin-right: 20px;
    height: max-content;
}

.ls-recommendation-view--buttons {
    > div {
        width: 370px;
    }

    > :nth-child(n + 2) {
        margin-top: 20px;
    }

    @media (min-width: $desktop) {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        height: max-content;
        > :nth-child(n + 2) {
            margin-top: 0;
        }
        > :nth-child(n + 3) {
            margin-top: 20px;
        }
        > :nth-child(even) {
            margin-left: 20px;
        }
    }
}
</style>
